<app-dialog class="load-scenario-dialog">
  <ng-container dialog-title>
    <label class="title">{{ 'module.modals.loadScenario.savedScenariosHeaderLabelText' | translate }}</label>
  </ng-container>

  <ng-container dialog-content>
    <div class="scenario-list">
      <div class="scenario-item" *ngFor="let scenario of scenarioList; trackBy: trackByFn">
        <app-scenario-item [scenario]="scenario" (loadEvent)="loadScenario($event)" (deleteEvent)="deleteScenario($event)"></app-scenario-item>
      </div>
    </div>
  </ng-container>

  <ng-container dialog-actions>
    <div (click)="openModal()">
      <span class="fa fa-plus-square"></span>
      <label class="footer-name">{{ 'module.modals.loadScenario.createNewScenarioFooterLabelText' | translate }}</label>
    </div>
  </ng-container>
</app-dialog>
